import { LanguageActionTypes } from "./constants";
import {
  getLanguageByCode,
  DEFAULT_LANGUAGE_CODE,
} from "./languages";

const defaultLang = getLanguageByCode(DEFAULT_LANGUAGE_CODE)!;
const initialState = {
  code: defaultLang.code,
  name: defaultLang.name,
  flag: defaultLang.flag,
};

const languageReducer = (
  state = initialState,
  action: { type: string; payload?: { code: string; name: string; flag: string } }
) => {
  switch (action.type) {
    case LanguageActionTypes.UPDATE_LANGUAGE:
      return action.payload
        ? {
            ...state,
            code: action.payload.code,
            name: action.payload.name,
            flag: action.payload.flag,
          }
        : state;
    default:
      return { ...state };
  }
};

export default languageReducer;
